import { __extends } from "tslib";
import { SlotTraitInfo } from './SlotTraitInfo';
var ClassTraitInfo = /** @class */ (function (_super) {
    __extends(ClassTraitInfo, _super);
    function ClassTraitInfo(abc, kind, name, slot, classInfo) {
        var _this = _super.call(this, abc, kind, name, slot, 0, 0, -1) || this;
        _this.classInfo = classInfo;
        return _this;
    }
    return ClassTraitInfo;
}(SlotTraitInfo));
export { ClassTraitInfo };
